import { connect } from 'react-redux';
import { AppState } from 'app/store';
import ReloadRequiredNotifier from 'app/components/header/ReloadRequiredNotifier';
import { getInteractiveReloadRequired } from 'app/remote/client/selectors';

const mapStateToProps = (state: AppState) => ({ visible: getInteractiveReloadRequired(state) });

const ReloadRequiredNotifierContainer = connect(mapStateToProps, null)(ReloadRequiredNotifier);

export default ReloadRequiredNotifierContainer;
